import { apiSlice as api } from "@/store/rtk-api/apiSlice"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation<IRegisterResponse, IRegisterRequest>({
      query: (data) => ({
        url: "/v1/auth/register",
        method: "POST",
        data,
      }),
    }),
    login: builder.mutation<ILoginResponse, ILoginRequest>({
      query: (data) => ({
        url: "/v1/auth/login",
        method: "POST",
        data,
      }),
    }),
    verify: builder.mutation<IVerifyResponse, IVerifyRequest>({
      query: (data) => ({
        url: "/v1/auth/verify",
        method: "POST",
        data,
        suppressErrorToast: true,
      }),
    }),
    googleLogin: builder.mutation<IVerifyResponse, IGoogleLoginRequest>({
      query: (data) => ({
        url: "/v1/auth/google",
        method: "POST",
        data,
      }),
    }),
    beginAuthenticatorSetup: builder.mutation<IAuthenticatorSetup, void>({
      query: () => ({ url: "/v1/auth/authenticator/setup", method: "POST", suppressErrorToast: true }),
    }),
    confirmAuthenticatorSetup: builder.mutation<{ success: boolean }, { code: string }>({
      query: (data) => ({ url: "/v1/auth/authenticator/confirm", method: "POST", data, suppressErrorToast: true }),
    }),
    disableAuthenticator: builder.mutation<{ success: boolean }, void>({
      query: () => ({ url: "/v1/auth/authenticator", method: "DELETE", suppressErrorToast: true }),
    }),
    logout: builder.mutation<ILogoutResponse, void>({
      query: () => ({
        url: "/v1/auth/logout",
        method: "POST",
      }),
    }),
  }),
})

export const {
  useRegisterMutation,
  useLoginMutation,
  useVerifyMutation,
  useGoogleLoginMutation,
  useLogoutMutation,
  useBeginAuthenticatorSetupMutation,
  useConfirmAuthenticatorSetupMutation,
  useDisableAuthenticatorMutation,
} = injectedRtkApi

export default injectedRtkApi

interface IRegisterRequest {
  email: string
  firstName: string
  lastName: string
}

interface IRegisterResponse {
  success: boolean
  message?: string
  error?: string
}

interface ILogoutResponse {
  success: boolean
  message?: string
  error?: string
}

interface ILoginRequest {
  email: string
  method?: "auto" | "email"
}

interface ILoginResponse {
  success: boolean
  error?: string
  method?: "email" | "authenticator"
}

interface IVerifyRequest {
  email: string
  otp: string
  method?: "email" | "authenticator"
}

export interface IAuthenticatorSetup {
  success: boolean
  secret: string
  otpauthUri: string
  qrCodeDataUrl: string
  expiresAt: string
}

interface IGoogleLoginRequest {
  credential: string
}

export interface IVerifyResponse {
  success: boolean
  error?: string
  message?: string
  isNew: boolean
}
